export default __webpack_public_path__ + "static/media/error.ac030579.png";